import { useQuery } from '@tanstack/react-query';
import { Sector } from '../api/sectorsApi/interfaces';
import {
  getLeafSectorList,
  getSectorList,
  getSubSectorList,
} from '../api/sectorsApi';

export const useGetSectorList = (enabled: boolean = true) => {
  return useQuery<Sector[]>({
    queryFn: () => getSectorList(),
    queryKey: ['sector-list'],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled,
  });
};

export const useGetLeafSectorList = (enabled: boolean = true) => {
  return useQuery<Sector[]>({
    queryFn: () => getLeafSectorList(),
    queryKey: ['sector-leaf-list'],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled,
  });
};

export const useGetSubSectorList = (
  parentId?: number,
  enabled: boolean = true
) => {
  return useQuery<Sector[]>({
    queryFn: () => getSubSectorList(parentId || 0),
    queryKey: ['sub-sector-list', parentId],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: enabled && !!parentId,
  });
};
